import PropTypes from 'prop-types';
import React from 'react';

import staticURL from 'lib/staticURL';

import NotificationBanner from './NotificationBanner';

interface ReferralBannerProps {
  onCloseBanner: () => {};
}

export function AcademicReferralBanner(props: ReferralBannerProps): JSX.Element {
  return (
    <NotificationBanner
      onCloseBanner={props.onCloseBanner}
      imageURL={staticURL('/static/img/benchling_gold_image.png')}
      title={<b>Get Benchling Gold</b>}
    >
      <a href="/invite" rel="noopener noreferrer" target="_blank">
        Invite your colleagues
      </a>{' '}
      to Benchling! When five of your referrals sign up, you'll receive extra space and exclusive access to an
      enterprise feature, Benchling Sync.
    </NotificationBanner>
  );
}

AcademicReferralBanner.propTypes = {
  onCloseBanner: PropTypes.func.isRequired,
};
